/**
 * Should be deprecated. We will see.
 */

export class ValidationError {

    constructor(
        public target: string,
        public message: string
    ) {
    }

}
